(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-premium"] && !Shopify.designMode) return;
  try {
    
/* Novoom contact routing */
document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('[data-nv-contact-topic]');
  var formWrap = document.getElementById('nv-contact-shopify-form');
  var topicInput = document.getElementById('ContactForm-topic');
  var body = document.getElementById('ContactForm-body');

  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      var topic = link.getAttribute('data-nv-contact-topic') || '';

      if (topicInput) {
        topicInput.value = topic;
      }

      if (body && !body.value.trim()) {
        body.value = 'Anliegen: ' + topic + '\n\n';
      }

      if (formWrap) {
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });

        window.setTimeout(function () {
          if (body) body.focus();
        }, 450);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelvintabelle-interaktiv"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function kelvinToRGB(temp) {
    var t = temp / 100;
    var r, g, b;
    if (t <= 66) {
      r = 255;
      g = 99.4708025861 * Math.log(t) - 161.1195681661;
      if (t <= 19) b = 0;
      else b = 138.5177312231 * Math.log(t - 10) - 305.0447927307;
    } else {
      r = 329.698727446 * Math.pow(t - 60, -0.1332047592);
      g = 288.1221695283 * Math.pow(t - 60, -0.0755148492);
      b = 255;
    }
    function clamp(v){ return Math.max(0, Math.min(255, Math.round(v))); }
    return {r:clamp(r),g:clamp(g),b:clamp(b)};
  }

  function infoFor(k) {
    if (k < 2400) return {cat:'Extra warmweiß',effect:'Sehr gemütlich & dekorativ',use:'Gastronomie · Akzentlicht · Außenambiente',desc:'Sehr warmes, bernsteinfarbenes Licht für besonders atmosphärische Anwendungen.'};
    if (k < 2850) return {cat:'Sehr warmweiß',effect:'Gemütlich & weich',use:'Wohnzimmer · Schlafzimmer · Lounge',desc:'Sehr warmes Licht mit klassischer Wohnwirkung – besonders angenehm für Ruhe- und Aufenthaltsbereiche.'};
    if (k < 3500) return {cat:'Warmweiß',effect:'Wohnlich & ausgewogen',use:'Wohnzimmer · Essbereich · Gastronomie',desc:'Warm und ausgewogen – beliebt in Wohnräumen, Gastronomie und vielen dekorativen Leuchten.'};
    if (k < 4500) return {cat:'Neutralweiß',effect:'Klar & funktional',use:'Küche · Bad · Büro · Arbeitsbereiche',desc:'Neutraleres, klares Licht für funktionale Bereiche und überall dort, wo eine sachliche Lichtwirkung gewünscht ist.'};
    if (k < 5800) return {cat:'Kühl-neutral',effect:'Aktiv & sachlich',use:'Werkstatt · Technik · Funktionsräume',desc:'Kühleres Licht mit sachlicher Wirkung – eher für funktionale und technische Anwendungen.'};
    return {cat:'Tageslichtweiß',effect:'Sehr kühl & technisch',use:'Spezielle Arbeits- und Funktionsbereiche',desc:'Sehr kühle, tageslichtähnliche Lichtwirkung für spezielle funktionale Anwendungen.'};
  }

  var tool = document.querySelector('[data-kelvin-tool]');
  var hero = document.querySelector('[data-kelvin-hero]');
  if (!tool) return;

  var range = tool.querySelector('[data-kelvin-range]');
  var stage = tool.querySelector('[data-kelvin-stage]');
  var value = tool.querySelector('[data-kelvin-value]');
  var category = tool.querySelector('[data-kelvin-category]');
  var description = tool.querySelector('[data-kelvin-description]');
  var effect = tool.querySelector('[data-kelvin-effect]');
  var use = tool.querySelector('[data-kelvin-use]');
  var shop = tool.querySelector('[data-kelvin-shop]');
  var quick = tool.querySelectorAll('[data-kelvin-set]');
  var heroValue = document.querySelector('[data-kelvin-hero-value]');
  var heroLabel = document.querySelector('[data-kelvin-hero-label]');
  var orb = document.querySelector('[data-kelvin-orb]');

  function setKelvin(k, scroll) {
    k = Math.max(1800, Math.min(6500, Number(k) || 3000));
    range.value = k;
    var rgb = kelvinToRGB(k);
    var info = infoFor(k);
    var color = 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
    var pale = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',.78)';

    stage.style.background = 'radial-gradient(circle at 50% 50%, #fff 0%, ' + color + ' 58%, ' + pale + ' 100%)';
    stage.style.boxShadow = 'inset 0 0 110px rgba(255,255,255,.64), 0 0 45px ' + pale;
    value.textContent = k + ' K';
    category.textContent = info.cat;
    description.textContent = info.desc;
    effect.textContent = info.effect;
    use.textContent = info.use;
    shop.textContent = 'Produkte mit ' + k + ' K ansehen →';
    shop.href = '/search?q=' + encodeURIComponent(k + 'K') + '&type=product';

    if (heroValue) heroValue.textContent = k + ' K';
    if (heroLabel) heroLabel.textContent = info.cat;
    if (orb) {
      orb.style.background = 'radial-gradient(circle at 50% 45%, #fff 0%, ' + color + ' 46%, ' + pale + ' 78%, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',.12) 100%)';
      orb.style.boxShadow = '0 0 90px ' + pale + ',0 24px 80px rgba(0,0,0,.12)';
    }
    if (hero) {
      var cool = k > 4000 ? '#dceaff' : '#fff1d8';
      hero.style.background = 'linear-gradient(135deg,' + color + ' 0%,' + cool + ' 100%)';
    }

    quick.forEach(function(btn){
      btn.classList.toggle('is-active', Number(btn.dataset.kelvinSet) === k);
    });

    if (scroll) tool.scrollIntoView({behavior:'smooth',block:'start'});
  }

  range.addEventListener('input', function(){ setKelvin(range.value, false); });
  quick.forEach(function(btn){
    btn.addEventListener('click', function(){ setKelvin(btn.dataset.kelvinSet, false); });
  });

  document.querySelectorAll('[data-kelvin-jump]').forEach(function(btn){
    btn.addEventListener('click', function(){ setKelvin(btn.dataset.kelvinJump, true); });
  });
  document.querySelectorAll('[data-room-k]').forEach(function(btn){
    btn.addEventListener('click', function(){ setKelvin(btn.dataset.roomK, true); });
  });

  setKelvin(3000, false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lichtplanung-premium"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-plan-selector]');
  if (!root) return;

  var buttons = root.querySelectorAll('[data-plan-type]');
  var eyebrow = root.querySelector('[data-plan-eyebrow]');
  var title = root.querySelector('[data-plan-title]');
  var list = root.querySelector('[data-plan-list]');

  var data = {
    wohnen: {
      eyebrow: 'WOHNRAUM',
      title: 'Für eine gute Wohnraumplanung helfen uns:',
      items: [
        'Raummaße oder Grundriss',
        'Deckenhöhe und vorhandene Anschlüsse',
        'Nutzung der einzelnen Bereiche',
        'Gewünschte Lichtfarbe und Stilrichtung',
        'Fotos oder Skizzen des Raumes'
      ]
    },
    gewerbe: {
      eyebrow: 'GEWERBE',
      title: 'Für Gewerbe- und Objektflächen sind besonders hilfreich:',
      items: [
        'Grundriss mit Flächen und Nutzung',
        'Raumhöhe und Montageart',
        'Arbeits-, Präsentations- oder Verkaufsbereiche',
        'Gewünschte Lichtfarbe und Farbwiedergabe',
        'Vorhandene Schaltung, DALI oder Schienensystem'
      ]
    },
    aussen: {
      eyebrow: 'AUßENBEREICH',
      title: 'Für Außenbereiche benötigen wir idealerweise:',
      items: [
        'Skizze oder Foto von Fassade, Weg oder Garten',
        'Positionen der vorhandenen Stromauslässe',
        'Gewünschte Lichtwirkung und Reichweite',
        'Montagehöhe und relevante Abstände',
        'Besondere Anforderungen an Schutzart oder Nutzung'
      ]
    },
    schiene: {
      eyebrow: 'SCHIENENSYSTEM',
      title: 'Für die Planung eines Schienensystems helfen uns:',
      items: [
        'Gewünschte Schienenlänge und Verlauf',
        'Position der Einspeisung',
        'Anzahl und Art der Strahler oder Pendelleuchten',
        '1-Phasen oder 3-Phasen, falls bereits festgelegt',
        'Skizze mit Verbindern, Ecken und Abzweigungen'
      ]
    }
  };

  function render(type) {
    var entry = data[type] || data.wohnen;
    eyebrow.textContent = entry.eyebrow;
    title.textContent = entry.title;
    list.innerHTML = entry.items.map(function (item) {
      return '<li>' + item + '</li>';
    }).join('');
    buttons.forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.planType === type);
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      render(button.dataset.planType);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumentabelle-premium"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-lumen-calculator]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-lux]');
    var area = root.querySelector('[data-area]');
    var perLight = root.querySelector('[data-per-light]');
    var totalEl = root.querySelector('[data-total-lumen]');
    var rangeEl = root.querySelector('[data-range-lumen]');
    var countEl = root.querySelector('[data-light-count]');
    var roomNote = root.querySelector('[data-room-note]');
    var room = 'Wohnzimmer';
    var lux = 150;

    function formatNumber(value) {
      return new Intl.NumberFormat('de-DE').format(Math.round(value));
    }

    function update() {
      var sqm = Math.max(1, parseFloat(area.value) || 1);
      var per = Math.max(1, parseInt(perLight.value, 10) || 500);
      var total = Math.round(sqm * lux);
      var low = Math.round(total * 0.85);
      var high = Math.round(total * 1.15);
      var count = Math.max(1, Math.ceil(total / per));

      totalEl.textContent = formatNumber(total) + ' lm';
      rangeEl.textContent = 'ca. ' + formatNumber(low) + '–' + formatNumber(high) + ' lm';
      countEl.textContent = count + (count === 1 ? ' Leuchte' : ' Leuchten');
      roomNote.textContent = room + ' · ca. ' + lux + ' lx';
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        room = button.dataset.room || 'Raum';
        lux = parseInt(button.dataset.lux, 10) || 150;
        update();
      });
    });

    area.addEventListener('input', update);
    perLight.addEventListener('change', update);
    update();
  });

  document.querySelectorAll('[data-watt-switcher]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-lm]');
    var lmEl = root.querySelector('[data-watt-lm]');
    var ledEl = root.querySelector('[data-watt-led]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        button.classList.add('is-active');
        lmEl.textContent = '≈ ' + Number(button.dataset.lm).toLocaleString('de-DE') + ' lm';
        ledEl.textContent = button.dataset.led;
      });
    });
  });

  document.querySelectorAll('[data-kelvin-picker]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-kelvin]');
    var value = root.querySelector('[data-kelvin-value]');
    var copy = root.querySelector('[data-kelvin-copy]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        button.classList.add('is-active');
        value.textContent = button.dataset.kelvin;
        copy.textContent = button.dataset.copy;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
